/* Lucky Paw (Oct 15): Dealeasy cart bar shows "Buy 4 · 5th FREE".
   Visual only. The real deal (5 tees in cart = $29.95 off) is unchanged in Dealeasy.
   - Label under the 2nd bubble: "5 tees" -> "Buy 4 · 5th FREE 🎁"
   - At 4 tees the green bar fills past the 2nd bubble and the bubble lights up
   - At 4 tees the message says "🎉 Add 1 more tee, it's FREE! 🐾"
   To undo: delete the lps-cart-bar.js line in snippets/lp-styles.liquid. */
(function () {
  var LABEL = 'Buy 4 · 5th FREE 🎁';
  var MSG4 = '🎉 Add 1 more tee, it’s FREE! 🐾';
  /* Dealeasy spaces 2 bubbles at 25% (2 tees) and 75% (5 tees). Turn its bar width back into a tee count. */
  function teesFromWidth(w) {
    if (w <= 25) return (w / 25) * 2;
    if (w <= 75) return 2 + ((w - 25) / 50) * 3;
    return 5;
  }
  function fixBar(bar) {
    var labels = bar.querySelectorAll('.lb-cpb-cart-goal-value-text');
    if (labels.length !== 2) return;
    var second = labels[1];
    var t = second.textContent.trim();
    if (t !== LABEL) {
      if (!/^5 tees$/i.test(t)) return; /* only touch the Buy 4 bar */
      second.textContent = LABEL;
    }
    var tees = null;
    bar.querySelectorAll('.lb-cpb-progress-indicator').forEach(function (ind) {
      var cur = parseFloat(ind.style.width);
      if (isNaN(cur)) return;
      if (ind.dataset.lpsW && Math.abs(cur - parseFloat(ind.dataset.lpsW)) < 0.05) {
        tees = parseFloat(ind.dataset.lpsTees);
        return; /* already ours */
      }
      var c = Math.round(teesFromWidth(cur) * 100) / 100;
      tees = c;
      var w = cur;
      if (c >= 4 && c < 5) w = 82;
      else if (c > 2 && c < 4) w = 25 + ((c - 2) / 2) * 50;
      if (w !== cur) {
        ind.dataset.lpsW = w;
        ind.dataset.lpsTees = c;
        ind.style.width = w + '%';
      }
    });
    if (tees === null) return;
    var markers = bar.querySelectorAll('.lb-cpb-multiple-goal-progress-marker');
    if (markers[1] && tees < 5) {
      markers[1].classList.toggle('lb-cpb-multiple-goal-progress-marker-unlocked', tees >= 4);
    }
    if (tees >= 4 && tees < 5) {
      var msg = bar.querySelector('.lb-cpb-progress-text');
      if (msg && msg.textContent.trim() !== MSG4) msg.textContent = MSG4;
    }
  }
  var queued = false;
  function run() {
    queued = false;
    document.querySelectorAll('.lb-cpb-progress-bar-container').forEach(fixBar);
  }
  function queue() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(run);
    }
  }
  new MutationObserver(queue).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  queue();
})();
